export default "__VITE_ASSET__B6TC02Le__"